export class ArchieveData{
    constructor(){
        this.name = '';
        this.categories = [];
        this.noOfTweets = 0;
        this.description = '';
        this.comments = [];
        this.date = '';
        this.id = 0;
        this.isShow = true;
    }
    name: string;
    categories: string[];
    noOfTweets: number;
    description: string;
    comments: Comment[];
    id: number;
    date: string;
    isShow: boolean;
}

export class Comment {
    constructor(){
        this.data ='';
        this.reputation = 0;
    }
   data: string;
   reputation: number;
}

export class  FilterArchive {
    constructor(){
        this.categories = [];
        this.noOfTweetsStart= 0;
        this.noOfTweetsEnd= 12400000;
        this.sortBy= 'Latest Activity';
        this.startDate = '02/07/2020';
        this.endDate = '31/05/2021';
    }
    categories?: string[];
    noOfTweetsStart: number;
    noOfTweetsEnd: number;
    sortBy?: string;
    startDate: string;
    endDate: string;
}